import React from 'react';
import { XCircle, Home, Heart } from 'lucide-react';
import { Button } from './ui/button';

const DonateCancel = () => {
  const params = new URLSearchParams(window.location.search);
  const reason = params.get('reason');

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFF7F1] via-[#FFEFE2] to-[#FFE4CF] flex items-center justify-center px-6 py-24">
      <div className="max-w-xl w-full bg-white rounded-3xl shadow-2xl p-10 text-center border border-[#FFE4CF]">
        <div className="w-20 h-20 rounded-full bg-slate-100 flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-slate-500" />
        </div>
        <h1 className="text-3xl font-extrabold text-[#0B3B44] mb-3">
          {reason === 'failed' ? 'Payment did not complete' : 'Donation cancelled'}
        </h1>
        <p className="text-slate-600 mb-8 leading-relaxed">
          {reason === 'failed'
            ? 'Your payment could not be processed. No amount has been charged. Please try again or use our bank transfer details.'
            : 'No problem — you can donate any time. Every rand helps us serve another meal.'}
        </p>
        <div className="flex flex-wrap gap-3 justify-center">
          <Button
            onClick={() => (window.location.href = '/#donate')}
            className="bg-[#F55B26] hover:bg-[#E14D1F] text-white font-semibold px-6 rounded-full"
          >
            <Heart className="w-4 h-4 mr-2" fill="white" />
            Try again
          </Button>
          <Button
            variant="outline"
            onClick={() => (window.location.href = '/')}
            className="border-2 border-[#0B3B44] text-[#0B3B44] hover:bg-[#0B3B44] hover:text-white font-semibold px-6 rounded-full"
          >
            <Home className="w-4 h-4 mr-2" />
            Return home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DonateCancel;
